<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('setupdefinition_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-clipboard-list</v-icon>{{ item['uuid'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-setupdefinition-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('profile.setupdefinition.uuid') }}</strong></td>
              <td>
                                    {{ item['uuid'] }}
              </td>

              <td><strong>{{ $t('profile.setupdefinition.extruderquantity') }}</strong></td>
              <td>
                {{ $n(item['extruderQuantity']) }}              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.setupdefinition.tempcontroler') }}</strong></td>
              <td>
                {{ $n(item['tempControler']) }}              </td>

              <td><strong>{{ $t('profile.setupdefinition.machine') }}</strong></td>
              <td>
                                    {{ item['machine'].name }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.setupdefinition.toolhead') }}</strong></td>
              <td>
                                    {{ item['toolHead'].name }}
              </td>

              <td><strong>{{ $t('profile.setupdefinition.materialsupply') }}</strong></td>
              <td>
                                    {{ item['materialSupply'].name }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.setupdefinition.printingsurface') }}</strong></td>
              <td>
                                    {{ item['printingSurface'].name }}
              </td>

            </tr>

          </tbody>
        </template>
      </v-simple-table>
      <template>
        <div class="setupdefinitionsub-list">
          <Toolbar />

          <v-container grid-list-xl fluid>
            <v-layout row wrap>
              <v-flex sm12>
                <h1>{{ $t('profile.setupdefinition.definitionssub') }}</h1>
              </v-flex>
              <v-flex lg12>
                <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
                  <SetupDefinitionSubFilterForm
                    ref="filterForm"
                    :values="filters"
                    slot="filter"
                  />
                </DataFilter>

                <br />

                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :items="items"
        :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
                  :loading="isLoading"
                  :loading-text="$t('global.loading')"
                  :options.sync="options"
                  :server-items-length="totalItems"
                  class="elevation-1"
                  item-key="@id"
                  @update:options="onUpdateOptions"
@click:row="showHandlerSubEvent"
                >

                  <ActionCell
                    slot="item.action"
                    slot-scope="props"
                    :handle-show="() => showHandlerSub(item,'SetupDefinitionSub',props.item)"
                  ></ActionCell>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </template>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import SetupDefinitionSubFilterForm from '../../components/setupdefinitionsub/Filter';
import DataFilter from '../../components/DataFilter';

const servicePrefix = 'SetupDefinition';

export default {
  name: 'SetupDefinitionShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
      ActionCell,
      SetupDefinitionSubFilterForm,
      DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('profile.setupdefinition.tool'), value: 'tool.name' },
        { text: this.$t('profile.setupdefinition.material'), value: 'material.name' },
        { text: this.$t('profile.setupdefinition.nozzle'), value: 'nozzle.name' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      filters: {
        'setupDefinition' : this.$route.params.id,
      },
      selected: []
    };
  },
  mixins: [ListMixin,ShowMixin,AccessMixin],
  computed: {
    ...mapFields('setupdefinition', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('setupdefinition', ['find']),
    ...mapGetters('setupdefinitionsub', {
      items: 'list'
    }),
    ...mapFields('setupdefinitionsub', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('setupdefinition', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),
    ...mapActions('setupdefinitionsub', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
    showHandlerSubEvent(value) {
      this.showHandlerSub(this.item,'SetupDefinitionSub',value);
    }
  }
};
</script>
